require('../css/main.scss');

const cvForm = require('./func/contact-jp');
const userLang = require('./func/lang-check');

window.addEventListener('DOMContentLoaded', run);

async function run(e) {}
